import * as yup from 'yup';

export const comissionedPayrollRegistrationValidations = yup.object().shape({
  establishments: yup
    .array()
    .min(1, 'Você precisa selecionar pelo menos um estabelecimento')
    .required()
});